import { FC } from 'react';
import Confirmation from '../Confirmation/Confirmation';
import Finish from '../Finish/Finish';
import Intro from '../Intro/Intro';
import Landing from '../Landing/Landing';
import Legal from '../Legal/Legal';
import LegalAccordion from '../LegalAccordion/LegalAccordion';
import MailDoBAnswer from '../MaiLDoBAnswer/MailDoBAnswer';
import MailDoBFinish from '../MailDoBFinish/MailDoBFinish';
import Interstitial from '../Interstitial/Interstitial';
import MultiSelectAnswer from '../MultiSelectAnswer/MultiSelectAnswer';
import PillSelectAnswer from '../PillSelectAnswer/PillSelectAnswer';
import SelectFinish from '../SelectFinish/SelectFinish';
import SingleSelectAnswer from '../SingleSelectAnswer/SingleSelectAnswer';
import TextAnswer from '../TextAnswer/TextAnswer';
import UploadImages from '../UploadImages/UploadImages';
import Welcome from '../Welcome/Welcome';
import { StepEditorProps } from './StepDialog';

/** Maps a persisted step `type` onto the editor that renders it. */
export const STEP_EDITORS: Record<string, FC<StepEditorProps>> = {
  Accordion: LegalAccordion,
  Confirmation,
  Finish,
  Intro,
  Landing,
  Legal,
  MailDoB: MailDoBAnswer,
  MailDoBFinish,
  Interstitial,
  MultiSelectAnswer,
  PillSelect: PillSelectAnswer,
  SelectFinish,
  SingleSelectAnswer,
  TextAnswer,
  UploadImages,
  Welcome,
};
